// Map for all the assets using the key as the resource key
// also specify the URL of the resource

// import { isRetina } from '@/scripts/utils';

export default {
  textures: {
    TABLE_CLOTH: {
      url: '/assets/textures/tablecloth.png',
    },
    SMOKE: {
      url: '/assets/textures/smoke.png',
    },
    TAIL_YELLOW: {
      url: '/assets/textures/tail-yellow.png',
    },
    TAIL_VIOLET: {
      url: '/assets/textures/tail-violet.png',
    },
    TAIL_AZURE: {
      url: '/assets/textures/tail-azure.png',
    },
    TAIL_RAINBOW: {
      url: '/assets/textures/tail-rainbow.png',
    },
    HEAD: {
      url: '/assets/textures/head.png',
    },
    FLOWER_1: {
      url: '/assets/textures/flower-1.png',
    },
    FLOWER_2: {
      url: '/assets/textures/flower-2.png',
    },
    FLOWER_3: {
      url: '/assets/textures/flower-3.png',
    },
    FLOWER_4: {
      url: '/assets/textures/flower-4.png',
    },
    FLOWER_5: {
      url: '/assets/textures/flower-5.png',
    },
    FLOWER_6: {
      url: '/assets/textures/flower-6.png',
    },
    FLOWER_1_SHADOW: {
      url: '/assets/textures/flower-1-shadow.png',
    },
    FLOWER_2_SHADOW: {
      url: '/assets/textures/flower-2-shadow.png',
    },
    FLOWER_3_SHADOW: {
      url: '/assets/textures/flower-3-shadow.png',
    },
    FLOWER_4_SHADOW: {
      url: '/assets/textures/flower-4-shadow.png',
    },
    FLOWER_5_SHADOW: {
      url: '/assets/textures/flower-5-shadow.png',
    },
    FLOWER_6_SHADOW: {
      url: '/assets/textures/flower-6-shadow.png',
    },
    FRUIT_1: {
      url: '/assets/textures/fruit-1.png',
    },
    FRUIT_2: {
      url: '/assets/textures/fruit-2.png',
    },
    FRUIT_3: {
      url: '/assets/textures/fruit-3.png',
    },
    FRUIT_1_SHADOW: {
      url: '/assets/textures/fruit-1-shadow.png',
    },
    FRUIT_2_SHADOW: {
      url: '/assets/textures/fruit-2-shadow.png',
    },
    FRUIT_3_SHADOW: {
      url: '/assets/textures/fruit-3-shadow.png',
    },
    CLOUD_1: {
      url: '/assets/textures/cloud-1.png',
    },
    CLOUD_2: {
      url: '/assets/textures/cloud-2.png',
    },
    CLOUD_3: {
      url: '/assets/textures/cloud-3.png',
    },
    CLOUD_4: {
      url: '/assets/textures/cloud-4.png',
    },
    OBSTACLE_1_SHADOW: {
      url: '/assets/textures/obstacle-1-shadow.png',
    },
    OBSTACLE_2_SHADOW: {
      url: '/assets/textures/obstacle-2-shadow.png',
    },
    OBSTACLE_3_SHADOW: {
      url: '/assets/textures/obstacle-3-shadow.png',
    },
    OBSTACLE_4_SHADOW: {
      url: '/assets/textures/obstacle-4-shadow.png',
    },
    WATER: {
      url: '/assets/textures/big-hole.png',
    },
    JUMP: {
      url: '/assets/textures/jump.png',
    },
    JUMP_SHADOW: {
      url: '/assets/textures/jump-shadow.png',
    },
    RIVER_BACK: {
      url: '/assets/textures/river-back.png',
    },
    SCORE_LINE: {
      url: '/assets/textures/score-line.png',
    },
    SCORE_LINE_SHADOW: {
      url: '/assets/textures/score-line-shadow.png',
    },
    ENEMY_SHADOW: {
      url: '/assets/textures/enemy-shadow.png',
    },
    BUTTERFLY_SHADOW: {
      url: '/assets/textures/butterfly-shadow.png',
    },
    START_LEAF_LEFT: {
      url: '/assets/textures/start-leaf-left.png',
    },
    START_LEAF_RIGHT: {
      url: '/assets/textures/start-leaf-right.png',
    },
  },
  sprites: {
    WAVE: {
      url: '/assets/sprites/wave.json',
    },
    HOLE_SMALL: {
      url: '/assets/sprites/hole-small.json',
    },
    HOLE_MID: {
      url: '/assets/sprites/hole-mid.json',
    },
    BUBBLE: {
      url: '/assets/sprites/bubble.json',
    },
    RIVER: {
      url: '/assets/sprites/river.json',
    },
    SUBMARINE: {
      url: '/assets/sprites/submarine.json',
    },
    BUTTERFLY: {
      url: '/assets/sprites/butterfly.json',
    },
    BUTTERFLY_SHIELD: {
      url: '/assets/sprites/butterfly-shield.json',
    },
    BUTTERFLY_SHIELD_BACK: {
      url: '/assets/sprites/butterfly-shield-back.json',
    },
    BUTTERFLY_IN: {
      url: '/assets/sprites/butterfly-in.json',
    },
    OBSTACLE_1: {
      url: '/assets/sprites/obstacle-1.json',
    },
    OBSTACLE_2: {
      url: '/assets/sprites/obstacle-2.json',
    },
    OBSTACLE_3: {
      url: '/assets/sprites/obstacle-3.json',
    },
    OBSTACLE_4: {
      url: '/assets/sprites/obstacle-4.json',
    },
    ENEMY: {
      url: '/assets/sprites/enemy.json',
    },
    CONFETTI_FULL: {
      url: '/assets/sprites/confetti-full.json',
    },
    SCORE_CONFETTI: {
      url: '/assets/sprites/score-confetti.json',
    },
    START: {
      url: '/assets/sprites/start.json',
    },
    FALL: {
      url: '/assets/sprites/fall.json',
    },
    WAVE_LOOP_1: {
      url: '/assets/sprites/wave-loop-1.json',
    },
    WAVE_LOOP_2: {
      url: '/assets/sprites/wave-loop-2.json',
    },
  },
};
